import React, { useEffect, useContext, useState } from "react";
import "./mobileDatatableStyles.css";
import { useNavigate } from "react-router-dom";
import { ESTIMATION_DOC_DOWNLOAD } from "../../constants";
import axios from "axios";
import {
  Chip,
  Collapse,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  Grid,
  Table,
  Tooltip,
  IconButton,
  TablePagination,
} from "@mui/material";
import LongTextComponent from "../Leads Page/LongTextComponent";
import leadFormStyles from "../Leads Page/leadFormStyles.module.css";
import moment from "moment";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";

function MobileEstimationGeneratedDatatable({
  data,
  setSeverity,
  setMessage,
  setOpenSnackbar,
  setLoading,
}) {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [expandedRows, setExpandedRows] = useState([]);

  const handleRowClick = (index) => {
    const newExpandedRows = expandedRows.includes(index)
      ? expandedRows.filter((i) => i !== index)
      : [...expandedRows, index];
    setExpandedRows(newExpandedRows);
  };

  const formatDate = (dateString) => moment(dateString).format("DD-MM-YYYY");

  const getColorForTag = (tag) => {
    switch (tag.toLowerCase()) {
      case "hot":
        return "error"; // React blue
      case "warm":
        return "warning"; // JavaScript yellow
      case "cold":
        return "info"; // UI dark blue
      case "generated":
        return "success";
      default:
        return "default"; // Default gray
    }
  };

  const rowExpansionTemplate = (data) => (
    <Grid container spacing={1} p={1}>
      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Estimation Requirement:</Typography>
        <Typography variant="body2">
          {data.EstimationRequirement || "-"}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Firm/Farmer Name:</Typography>
        <Typography variant="body2">{data.firm_farmer_name || "-"}</Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Estimation Number:</Typography>
        <Typography variant="body2">{data.estimationNumber || "-"}</Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Estimation Amount:</Typography>
        <Typography variant="body2">{data.estimation_amount || "-"}</Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Estimation Request Date:</Typography>
        <Typography variant="body2">{data.Estimation_request_date}</Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Estimation Generated Date:</Typography>
        <Typography variant="body2">
          {data.Estimation_generated_date}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Category:</Typography>
        <Chip
          label={data.category}
          color={getColorForTag(data.category)}
          size="small"
          sx={{ textTransform: "capitalize" }}
        />
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Sub-Category:</Typography>
        <Typography variant="body2">{data.sub_category || "-"}</Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Follow-up Date:</Typography>
        <Typography variant="body2">{data.follow_up_date || "-"}</Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Closure Month:</Typography>
        <Typography variant="body2">{data.closure_month || "-"}</Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Number of Sheds:</Typography>
        <Typography variant="body2">{data.NumberOfSheds || "-"}</Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Shed Dimensions:</Typography>
        <Typography variant="body2">{`${data.ShedLength || "-"} x ${
          data.ShedWidth || "-"
        }`}</Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Model Type:</Typography>
        <Typography variant="body2">{data.ModalType || "-"}</Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Power Supply:</Typography>
        <Typography variant="body2" sx={{ textTransform: "capitalize" }}>
          {data.PowerSupply || "-"}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Water Supply:</Typography>
        <Typography variant="body2">
          {data.WaterSupply ? "Yes" : "No"}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">C-Shape:</Typography>
        <Typography variant="body2">{data.CShape ? "Yes" : "No"}</Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Civil Constructed Started:</Typography>
        <Typography variant="body2">
          {data.CivilConstructedStarted ? "Yes" : "No"}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Curtain Requirement:</Typography>
        <Typography variant="body2">
          {data.CurtainRequirment ? "Yes" : "No"}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Equipment Placement Length:</Typography>
        <Typography variant="body2">
          {data.EquipementPlacementLength || "-"}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Side-Wall Column To Column Gap:</Typography>
        <Typography variant="body2">
          {data.SideWallColumnToColumnGap || "-"}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Diesel Brooder Requirment:</Typography>
        <Typography variant="body2">
          {data.DiselBrooderRequirment || "-"}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Estimation Remarks:</Typography>
        <Typography variant="body2" sx={{ textAlign: "end" }}>
          <LongTextComponent
            text={
              data.estimation_remarks === undefined ||
              data.estimation_remarks === null
                ? "-"
                : data.estimation_remarks
            }
            maxLength={50}
          />
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Remarks:</Typography>
        <Typography variant="body2" sx={{ textAlign: "end" }}>
          <LongTextComponent
            text={
              data.Remarks === undefined || data.Remarks === null
                ? "-"
                : data.Remarks
            }
            maxLength={50}
          />
        </Typography>
      </Grid>
    </Grid>
  );

  const handleDownloadDoc = (row) => {
    setLoading(true);

    const fromData = {
      estimation_id: row.estimation_id,
      download_done: true,
      employeeId: localStorage.getItem("username"),
    };

    axios({
      method: "post",
      url: `${ESTIMATION_DOC_DOWNLOAD}`,
      data: fromData,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        // Validate response
        const contentType = response.headers["content-type"];

        // Check if the response is a valid ZIP file
        if (
          contentType !== "application/zip" &&
          contentType !== "application/x-zip-compressed"
        ) {
          throw new Error("Invalid file type");
        }

        const blob = new Blob([response.data], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // Generate a more descriptive filename
        const filename = `Documents_${row.estimation_id}_${
          new Date().toISOString().split("T")[0]
        }.zip`;
        link.setAttribute("download", filename);

        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url); // Clean up after download

        setLoading(false);
        setSeverity("success");
        setMessage("Documents Downloaded Successfully");
        setOpenSnackbar(true);
      })
      .catch((error) => {
        setLoading(false);

        // Detailed error logging and user feedback
        console.error("Download error:", error);

        let errorMessage = "Unable to Download.";

        if (error.response) {
          // Check if error response is a Blob
          if (error.response.data instanceof Blob) {
            // Convert Blob to text (without await)
            error.response.data
              .text()
              .then((text) => {
                errorMessage = text || "Server error occurred";
                setSeverity("error");
                setMessage(errorMessage);
                setOpenSnackbar(true);
              })
              .catch(() => {
                setSeverity("error");
                setMessage(errorMessage);
                setOpenSnackbar(true);
              });
          } else {
            // Use existing error response or default message
            errorMessage = error.response.data || errorMessage;
            setSeverity("error");
            setMessage(errorMessage);
            setOpenSnackbar(true);
          }
        } else if (error.request) {
          // The request was made but no response was received
          setSeverity("error");
          setMessage("No response received from server");
          setOpenSnackbar(true);
        } else {
          // Something happened in setting up the request that triggered an Error
          setSeverity("error");
          setMessage(errorMessage);
          setOpenSnackbar(true);
        }
      });
  };

  const paginatedData = data.slice(
    page * rowsPerPage,
    (page + 1) * rowsPerPage
  );

  return (
    <>
      <Paper>
        <TableContainer
          sx={{
            boxShadow: 2,
            borderRadius: "8px",
            margin: "8px 0",
          }}
        >
          <Table
            sx={{
              minWidth: 250,
              height: "100%",
              tableLayout: "fixed", // Ensures equal column width distribution
            }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
                <TableCell
                  align="left"
                  sx={{
                    padding: 0,
                    fontWeight: "bold",
                    width: 10,
                  }}
                ></TableCell>
                <TableCell
                  align="left"
                  sx={{
                    padding: 1,
                    width: 30,
                    fontWeight: "bold",
                  }}
                >
                  SNo
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    padding: 1,
                    fontWeight: "bold",
                  }}
                >
                  Firm/Farmer Name
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    padding: 1,
                    fontWeight: "bold",
                  }}
                >
                  Status
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    padding: 1,
                    fontWeight: "bold",
                    backgroundColor: "#EEF0F4",
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No Data Available Yet.
                  </TableCell>
                </TableRow>
              ) : (
                paginatedData.map((row, index) => (
                  <React.Fragment key={row.SNo}>
                    <TableRow sx={{ cursor: "pointer" }}>
                      {/* Expand Action */}
                      <TableCell align="left" sx={{ padding: 0 }}>
                        <button onClick={() => handleRowClick(index)}>
                          {expandedRows.includes(index) ? (
                            <ArrowDropDownIcon />
                          ) : (
                            <ArrowRightIcon />
                          )}
                        </button>
                      </TableCell>

                      {/* Other Columns */}
                      <TableCell align="center">
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ wordBreak: "break-word" }}
                      >
                        {row.firm_farmer_name}
                      </TableCell>
                      <TableCell align="center" sx={{ textDecoration: "none" }}>
                        <Chip
                          label={row.status}
                          color={getColorForTag(row.status)}
                          size="small"
                          sx={{ textTransform: "capitalize" }}
                        />
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ backgroundColor: "#EEF0F4" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Tooltip title="Download" arrow>
                            <IconButton
                              style={{
                                border: "1px solid",
                                borderRadius: "4px",
                                padding: "2px",
                                width: "24px",
                                height: "24px",
                                justifyContent: "center",
                                alignItems: "center",
                                marginRight: "5px",
                                backgroundColor: "#fff",
                              }}
                              color="primary"
                              onClick={() => handleDownloadDoc(row)}
                            >
                              <DownloadForOfflineIcon
                                fontSize="small"
                                color="primary"
                              />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Collapse Row */}
                    {expandedRows.includes(index) && (
                      <TableRow>
                        <TableCell colSpan={5} sx={{ padding: 0 }}>
                          <Collapse in={expandedRows.includes(index)}>
                            <Box
                              sx={{
                                padding: 2,
                                overflowX: "auto", // Add horizontal scrolling if content exceeds container width
                              }}
                            >
                              {rowExpansionTemplate(row)}
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={data.length} // Total rows
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 20, 25]} // Hide rows per page selection
        />
      </Paper>
    </>
  );
}

export default MobileEstimationGeneratedDatatable;
